<template>
  <div class="page">
    <AppTopHeader />

    <main class="container">
      <section class="hero">
        <div>
          <h1>{{ $t('welcome.hero.title') }}</h1>
          <p>{{ $t('welcome.hero.subtitle') }}</p>
          <button type="button" class="primary-btn cta-button" @click="goToDiscoverFromCTA">{{ $t('welcome.hero.cta') }}</button>
        </div>
        <div class="hero-image">
          <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuCRxPPzNRz7U33hwDzYD-EcICkfRAomjU-retUwCaqxGEYfB-Elu1zDmfLwxDG0J0KzJIkYdL91FTsvNfIJNDoyDqUt34M9RvH2S6BzLLB_7NkzS0pbTVvjQ1HeDJIsdw2Rv3SnmmKiX6Y8BpsrWrZCvJwjXyYayeKPzYQH8zTiKeRIkLtb7nd7kOl7gRobpCR7q16_MXkvix0eXLDpG3AgRUbKElkt7-dIGwXTPqDbr02AfYg6omoNXu5-Z4U97hf15z954oM7HwTj" alt="Hero"/>
          <div class="hero-badge">{{ $t('welcome.hero.heroBadge') }}<br/>Lisboa, PT</div>
        </div>
      </section>

      <section class="filters-rail" :aria-label="$t('welcome.filters.ariaLabel')">
        <div class="filters-bar">
          <div class="filter-field">
            <label class="filter-label" for="pub-max-cost">{{ $t('welcome.filters.budget') }}</label>
            <div class="filter-input-shell">
              <span class="filter-ico material-symbols-outlined" aria-hidden="true">payments</span>
              <input
                id="pub-max-cost"
                v-model.number="filters.maxCost"
                class="filter-native"
                type="number"
                min="0"
                :placeholder="$t('welcome.filters.budgetPlaceholder')"
              />
            </div>
          </div>
          <div class="filter-field">
            <label class="filter-label" for="pub-region">{{ $t('welcome.filters.region') }}</label>
            <div class="filter-input-shell">
              <span class="filter-ico material-symbols-outlined" aria-hidden="true">public</span>
              <select id="pub-region" v-model="filters.region" class="filter-native filter-select">
                <option value="">{{ $t('welcome.filters.regionAll') }}</option>
                <option value="Asia">{{ $t('welcome.filters.regionAsia') }}</option>
                <option value="Europe">{{ $t('welcome.filters.regionEurope') }}</option>
                <option value="Americas">{{ $t('welcome.filters.regionAmericas') }}</option>
              </select>
              <span class="filter-chev material-symbols-outlined" aria-hidden="true">expand_more</span>
            </div>
          </div>
          <div class="filter-field filter-field--country">
            <label class="filter-label">{{ $t('welcome.filters.country') }}</label>
            <div class="filter-input-shell filter-input-shell--country">
              <span class="filter-ico material-symbols-outlined" aria-hidden="true">flag</span>
              <CountrySearchField
                v-model="filters.countryCode"
                class="country-filter-slot"
                label=""
                :placeholder="$t('welcome.filters.countryPlaceholder')"
              />
            </div>
          </div>
          <div class="filter-field">
            <label class="filter-label" for="pub-city">{{ $t('welcome.filters.city') }}</label>
            <div class="filter-input-shell">
              <span class="filter-ico material-symbols-outlined" aria-hidden="true">location_city</span>
              <input
                id="pub-city"
                v-model.trim="filters.city"
                class="filter-native"
                type="text"
                :placeholder="$t('welcome.filters.cityPlaceholder')"
              />
            </div>
          </div>
          <div class="filter-field">
            <label class="filter-label" for="pub-type">{{ $t('welcome.filters.type') }}</label>
            <div class="filter-input-shell">
              <span class="filter-ico material-symbols-outlined" aria-hidden="true">landscape</span>
              <select id="pub-type" v-model="filters.type" class="filter-native filter-select">
                <option value="">{{ $t('welcome.filters.typeAny') }}</option>
                <option value="Cheap">{{ $t('welcome.filters.typeCheap') }}</option>
                <option value="Beach">{{ $t('welcome.filters.typeBeach') }}</option>
                <option value="Fast internet">{{ $t('welcome.filters.typeFastInternet') }}</option>
                <option value="City">{{ $t('welcome.filters.typeCity') }}</option>
              </select>
              <span class="filter-chev material-symbols-outlined" aria-hidden="true">expand_more</span>
            </div>
          </div>
          <div class="filter-field filter-field--action">
            <span class="filter-label filter-label--ghost" aria-hidden="true">{{ $t('welcome.filters.searchLabel') }}</span>
            <button type="button" class="search-btn" @click="goToDiscoverWithFilters">
              <span class="material-symbols-outlined search-btn-ico" aria-hidden="true">search</span>
              {{ $t('welcome.filters.searchBtn') }}
            </button>
          </div>
        </div>
      </section>

      <section class="featured">
        <h2>{{ $t('welcome.featured.title') }}</h2>
        <p>{{ $t('welcome.featured.subtitle') }}</p>
        <PublicFeaturedSkeleton v-if="featuredLoading" :count="3" />
        <div v-else class="cards">
          <article v-for="card in cards" :key="card.id" class="card clickable" @click="goToCity(card.id)">
            <img :src="card.imageUrl" :alt="card.name"/>
            <h3>{{ card.name }}, {{ card.country }}</h3>
            <small>R$ {{ formatCurrency(card.monthlyCost) }} {{ $t('welcome.featured.monthlyAvg') }}</small>
            <div class="card-meta">
              <span>Score {{ Number(card.scoreOverall || 0).toFixed(1) }}</span>
              <span v-for="tag in (card.tags || []).slice(0, 2)" :key="`${card.id}-${tag}`" class="tag">{{ tag }}</span>
            </div>
          </article>
        </div>
      </section>

      <section class="voice">
        <div>
          <span class="voice-label">{{ $t('welcome.voice.label') }}</span>
          <h3>{{ $t('welcome.voice.quote') }}</h3>
          <p>{{ $t('welcome.voice.author') }}</p>
        </div>
        <div class="voice-images">
          <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuBZFUUkh8xdwov9tVnX4FI9sqnW-384kqOjH2TcX9CRH4ubz_St62Td1qdrDgMcOMbvSPuBaVhrBR1-WFEVV91HfoQwpaXZQSm0DkGbWTqrxD6IbvzSKBGeURp7cUPm-1mzavq6GUL1UIZ-lwEMWcFrycwOxhvZwsMA62wbfLxb-ruLF5PN50xrTqoz7gk545Q0m7PXHeXoL3sQncw9rsB8A3sEa4jqhLHgoWJ_pBQulG1bJq1_RGBsIBurh2MWy97M13CtcqSyxUUv" alt="travel"/>
          <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuASiBEmAUrLPyEdKBCirWdtfoR1kslCpK0DJbqy-a23mQWOL_UXyO7SJCZpCKy9jIBmZ8GvddYQstm9KRYFQFheIQwdxGvA9i8zsXQ6Pojacf6h44A9mCsn_txk6uIxE6ReQ88hwShkEC2kCZmWNfwrE5HYm15_0WxCKllkAa3B0P1o8_X3eLIgA8CSS7KvyU8KVLXnLQgWtrx5dWp0FDVvmmnHujiAZV0WoqNc_Kc73SAEXCFHClVup_HU-bXN-VGoHb-D_89tC02e" alt="map"/>
        </div>
      </section>
    </main>

    <footer class="container footer">
      <strong>{{ $t('welcome.footer.brand') }}</strong>
      <div class="footer-links">
        <RouterLink to="/discover">{{ $t('welcome.footer.cities') }}</RouterLink>
        <RouterLink to="/privacy">{{ $t('app.footer.privacy') }}</RouterLink>
        <RouterLink to="/terms">{{ $t('app.footer.terms') }}</RouterLink>
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { useHead } from '@vueuse/head';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
/* eslint-enable no-unused-vars */
import axios from "axios";
import AppTopHeader from "../components/AppTopHeader.vue";
import PublicFeaturedSkeleton from "../components/skeleton/PublicFeaturedSkeleton.vue";
import CountrySearchField from "../components/CountrySearchField.vue";
import { flipmemoApiBase } from "@/config/flipmemoApi";

export default {
  name: 'PublicPage',
  components: { AppTopHeader, PublicFeaturedSkeleton, CountrySearchField },
  setup() {
    const { t, locale } = useI18n();
    useHead({
      title: computed(() => t('seo.welcome.title')),
      meta: [
        { name: 'description', content: computed(() => t('seo.welcome.description')) },
        { property: 'og:title', content: computed(() => t('seo.welcome.title')) },
        { property: 'og:description', content: computed(() => t('seo.welcome.description')) },
        { property: 'og:image', content: '/logo.svg' },
        { property: 'og:locale', content: computed(() => locale.value === 'pt-BR' ? 'pt_BR' : 'en_US') },
        { property: 'og:url', content: 'https://nomade-digital.com/' },
        { property: 'og:type', content: 'website' },
      ],
      link: [
        { rel: 'canonical', href: 'https://nomade-digital.com/' },
      ],
    });
  },
  data() {
    return {
      featuredLoading: true,
      cards: [],
      filters: {
        maxCost: null,
        region: "",
        countryCode: "",
        city: "",
        type: "",
      },
    };
  },
  mounted() {
    this.fetchDestinations();
  },
  methods: {
    apiBase() {
      return flipmemoApiBase;
    },
    formatCurrency(value) {
      return Number(value || 0).toLocaleString("pt-BR");
    },
    goToCity(id) {
      this.$router.push(`/city/${id}`);
    },
    goToDiscoverWithFilters() {
      const query = {};
      if (this.filters.maxCost && this.filters.maxCost > 0) query.maxCost = String(this.filters.maxCost);
      if (this.filters.region) query.region = this.filters.region;
      if (this.filters.countryCode) {
        query.countryCode = String(this.filters.countryCode).trim().toUpperCase();
      }
      if (this.filters.city) query.city = this.filters.city;
      if (this.filters.type) query.type = this.filters.type;
      this.$router.push({ path: "/discover", query });
    },
    goToDiscoverFromCTA() {
      this.goToDiscoverWithFilters();
    },
    async fetchDestinations() {
      this.featuredLoading = true;
      try {
        const response = await axios.get(`${this.apiBase()}/destinations`);
        this.cards = response.data || [];
      } catch (error) {
        this.cards = [];
      } finally {
        this.featuredLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.page { background: #0d1b2e; color: #e2eaf4; font-family: Inter, "Segoe UI", sans-serif; min-height: 100vh; }
.container { max-width: 1180px; margin: 0 auto; padding: 0 20px; }
main.container { padding-top: 96px; }
.hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  align-items: center;
  padding-bottom: 48px;
}
.hero h1 { font-size: 54px; line-height: 1.06; letter-spacing: -0.03em; margin: 0 0 14px; max-width: 560px; }
.hero p { margin: 0; font-size: 20px; color: #94adc8; max-width: 580px; }
.primary-btn {
  margin-top: 18px;
  display: inline-block;
  background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
  text-decoration: none;
  padding: 14px 28px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 17px;
  box-shadow: 0 10px 28px -6px rgba(0, 74, 198, 0.35);
  transition: opacity 0.15s ease, transform 0.1s ease;
}
.primary-btn:hover {
  opacity: 0.94;
}
.primary-btn:active {
  transform: scale(0.99);
}
.hero-image { position: relative; }
.hero-image img { width: 100%; height: 355px; object-fit: cover; border-radius: 1.25rem; box-shadow: 0 20px 50px -12px rgba(25, 28, 30, 0.12); }
.hero-badge {
  position: absolute;
  left: 16px;
  bottom: -14px;
  background: rgba(21, 35, 56, 0.92);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  line-height: 1.35;
  color: #e2eaf4;
  box-shadow: 0 12px 32px -4px rgba(25, 28, 30, 0.08);
}
.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
}
.filters-rail {
  margin-top: 8px;
  position: relative;
}
.filters-bar {
  position: relative;
  z-index: 5;
  background: #152338;
  border-radius: 1rem;
  box-shadow: 0 12px 32px -4px rgba(0, 0, 0, 0.3), 0 4px 20px -6px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.07);
  padding: 20px 24px 22px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
  align-items: flex-end;
}
.filter-field {
  flex: 1 1 148px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.filter-field--action {
  flex: 1 1 200px;
  max-width: 280px;
}
.filter-label {
  margin: 0;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94adc8;
  padding: 0 4px;
  line-height: 1.2;
}
.filter-label--ghost {
  visibility: hidden;
  user-select: none;
}
.filter-input-shell {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 48px;
  background: #081526;
  border-radius: 0.5rem;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}
.filter-input-shell:focus-within,
.filter-input-shell:has(.wrap.open) {
  background: #0d1b2e;
  box-shadow: 0 0 0 2px #4f8ef7;
}
.filter-ico {
  position: absolute;
  left: 12px;
  font-size: 22px;
  color: #94adc8;
  pointer-events: none;
  z-index: 2;
}
.filter-chev {
  position: absolute;
  right: 10px;
  font-size: 22px;
  color: #4a6080;
  pointer-events: none;
  z-index: 2;
}
.filter-native {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: none;
  background: transparent;
  padding: 12px 14px 12px 44px;
  font-size: 14px;
  font-weight: 500;
  color: #e2eaf4;
  font-family: inherit;
  border-radius: 0.5rem;
  outline: none;
}
.filter-native::placeholder {
  color: #4a6080;
}
.filter-select {
  padding-right: 40px;
  appearance: none;
  cursor: pointer;
}
.filter-input-shell--country {
  align-items: stretch;
}
.filter-input-shell--country :deep(.country-filter-slot) {
  flex: 1;
  min-width: 0;
  width: 100%;
}
.filter-input-shell--country :deep(.country-search) {
  gap: 0;
  flex: 1;
  min-width: 0;
}
.filter-input-shell--country :deep(.wrap) {
  flex: 1;
  min-height: 48px;
  display: flex;
  align-items: center;
}
.filter-input-shell--country :deep(.inp) {
  border: none;
  background: transparent;
  padding: 12px 36px 12px 44px;
  font-size: 14px;
  font-weight: 500;
  color: #e2eaf4;
  border-radius: 0.5rem;
  min-height: 48px;
  box-sizing: border-box;
  width: 100%;
}
.filter-input-shell--country :deep(.wrap.open .inp) {
  box-shadow: none;
}
.filter-input-shell--country :deep(.clear) {
  right: 8px;
}
.search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 0 22px;
  border: none;
  border-radius: 0.5rem;
  background: #4f8ef7;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}
.search-btn:hover {
  background: #3b7ef0;
}
.search-btn-ico {
  font-size: 22px;
}
.cta-button { border: 0; cursor: pointer; }
.featured { margin-top: 40px; }
.featured h2 { margin: 0; font-size: 32px; }
.featured p { color: #94adc8; margin: 8px 0 0; }
.cards { margin-top: 16px; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.card { background: #152338; border: 1px solid #1e3352; border-radius: 12px; padding: 8px; }
.card img { width: 100%; height: 212px; object-fit: cover; border-radius: 10px; }
.card h3 { margin: 8px 0 2px; font-size: 16px; }
.card small { color: #94adc8; }
.clickable { cursor: pointer; }
.card-meta { margin-top: 8px; display: flex; flex-wrap: wrap; gap: 6px; align-items: center; color: #94adc8; font-size: 12px; }
.tag { background: #1e3a8a; color: #93c5fd; border-radius: 999px; padding: 2px 8px; font-weight: 700; }
.voice { margin-top: 54px; display: grid; grid-template-columns: 1.2fr 1fr; gap: 14px; align-items: end; }
.voice-label {
  display: block;
  color: #4f8ef7;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.voice h3 { margin: 10px 0; font-size: 34px; line-height: 1.15; }
.voice p { color: #94adc8; margin: 0; }
.voice-images { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.voice-images img { width: 100%; height: 170px; object-fit: cover; border-radius: 12px; }
.footer { margin-top: 44px; border-top: 1px solid #1e3352; padding: 18px 20px; display: flex; justify-content: space-between; color: #94adc8; }
.footer-links { display: flex; gap: 12px; }
.footer-links a { text-decoration: none; color: #94adc8; font-size: 14px; }
@media (max-width: 980px) {
  .hero { grid-template-columns: 1fr; padding-bottom: 40px; }
  .filters-rail { margin-top: 4px; }
  .filter-field--action {
    flex: 1 1 100%;
    max-width: none;
  }
  .cards { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .voice { grid-template-columns: 1fr; }
}
@media (max-width: 640px) {
  .hero h1 { font-size: 40px; }
  .hero p { font-size: 18px; }
  .cards { grid-template-columns: 1fr; }
  .footer { flex-direction: column; gap: 8px; }
}
</style>
